import React from "react";
import styled, { keyframes } from "styled-components/macro";
import ActiveButton from "./ActiveButton";

const rotate = keyframes`
    to {
        transform: rotate(360deg);
    }
`;
const StyledLoadingButton = styled(ActiveButton)`
  cursor: not-allowed;
  :after {
    display: inline-block;
    vertical-align: middle;
    content: "";
    box-sizing: border-box;
    height: 1em;
    width: 1em;
    border-radius: 100%;
    border: 2px solid white;
    border-left-color: ${(props) => props.theme.colors.primary};
    margin-left: 0.5em;
    animation: ${rotate} 0.75s linear infinite;
  }
`;

type LoadingButtonProps = {
  className?: string;
};

const LoadingButton: React.FC<LoadingButtonProps> = ({
  children,
  className,
}) => {
  return (
    <StyledLoadingButton
      onClick={(e) => {
        e.preventDefault();
      }}
      data-testid="loading-button"
      className={className}
    >
      {children}
    </StyledLoadingButton>
  );
};

export default LoadingButton;
